/** Job statuses where a locked job must stay locked (cancelled = rejected/closed). */
export const JOB_STATUSES_BLOCKING_UNLOCK = ['completed', 'cancelled', 'rejected'] as const

export type JobLockStatus = (typeof JOB_STATUSES_BLOCKING_UNLOCK)[number] | string

export function isJobStatusBlockingUnlock(status?: string | null): boolean {
  const normalized = String(status ?? '').trim().toLowerCase()
  return (JOB_STATUSES_BLOCKING_UNLOCK as readonly string[]).includes(normalized)
}

export function canUnlockJob(job: {
  is_locked?: boolean | null
  status?: string | null
}): boolean {
  return Boolean(job.is_locked) && !isJobStatusBlockingUnlock(job.status)
}

export function canLockJob(job: {
  is_locked?: boolean | null
}): boolean {
  return !job.is_locked
}

export function getJobLockActionDisabledReason(job: {
  is_locked?: boolean | null
  status?: string | null
}): string | null {
  if (job.is_locked) {
    if (isJobStatusBlockingUnlock(job.status)) {
      return 'Unlock is not available for completed or rejected jobs.'
    }
    return null
  }

  return null
}
